import axios from 'axios'

const url = process.env.VUE_APP_FUNCTIONS_URL + '/func_search_faq';
const statisticsUrl = process.env.VUE_APP_STATISTICS_URL + '/func_register_statistics';

export default {
    async search({ commit }, word) {
        $("html,body").animate({scrollTop: $('.searchForm').offset().top});

        let results = []
        commit('setSearching', true)
        commit('setResults', [])
        commit('setIsSearched', false)

        try {
            const response = await axios.post(url,
                { searchWord: `${word}` },
                {
                    headers: {
                        "Content-Type": 'application/json',
                    }
                })

            results = response.data === null ? [] : response.data;
            // results[0]['Answer'] = "<div>仮の動画を入れています。確認をお願いします。</div><br /><br /><video src='https://lowson.s3.amazonaws.com/faqImages/mov_hts-samp003.mp4' width='300px' controls></video><br /><br /><div>仮の画像を入れています。確認をお願いします。</div><br /><br /><img src='https://lowson.s3.amazonaws.com/faqImages/sample_gree.png' />";
            // results[0]['Answer'] = "<img src='https://lowson.s3.amazonaws.com/faqImages/sample_gree.png' />";
            //chatbotflgが1のanswerがある場合はchatbotを出す
            commit('setUpperShow', false);
            results.map((item) => {
                if(item.ChatBotFlg === '1'){
                    commit('setUpperShow', true)
                }
            });
        } catch (err) {
            console.error(err);
        } finally {
            commit('setSearching', false)
            commit('setResults', results)
            commit('setIsSearched', true)
        }
    },
    async statistics({ commit }, {type, value}) {
        try {
            await axios.post(statisticsUrl,
                { Type: `${type}`,  Value: `${value}`},
                {
                    headers: {
                        "Content-Type": 'application/json',
                    }
                })
        } catch (err) {
        } finally {}
    }
}
